module.exports = __webpack_public_path__ + "img/PresupuestoIcon.6d5e684f.svg";